import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class DataSourceService {

  constructor(private activeRoute: ActivatedRoute, private httpclient: HttpClient) { }


  findInputValues(params, additionalData?) {
    var data = {};
    for (let i = 0; i < params.length; i++) {
      const p = params[i];
      data[p.paramName] = this.getParameterValue(p, additionalData);
    }
    return data;
  }



  getParameterValue(item, additionalData?) {
    // let data;
    switch (item.sourceType) {
      case 1:
        //static
        return item.paramValue;
      case 2:
        //router Parameter
        let paramData;
        this.activeRoute.paramMap.subscribe((param) => {
          if (param.has('params')) {
            paramData = param;
          }
        });
        return paramData;
      case 3:
        //Local Storage
        let localStorageValue = JSON.parse(localStorage.getItem(item.paramValue));
        if (localStorageValue) {
          return localStorageValue
        }
        return null;

      case 4:
        //Session Storage
        let sessionStorageValue = JSON.parse(sessionStorage.getItem(item.paramValue));
        if (sessionStorageValue) {
          return sessionStorageValue
        }
        return null;
      case 5:
        //User
        // data = this.user;
        break;
      case 6:
        return item;
      case 7:
        let itemValue = (additionalData[item.paramValue] && additionalData[item.paramValue].value) ? additionalData[item.paramValue].value : "";
        return itemValue;
      // return the value of html element
      default:
        return undefined;
        break;
    }
  }
}
